export const formatter = new Intl.NumberFormat('en-US',
    {
        style: 'currency',
        currency: 'USD',
        currencyDisplay: 'narrowSymbol'
    })

export const compactFormatter = (
    style?: keyof Intl.NumberFormatOptionsStyleRegistry | undefined, currency?: string
) => new Intl.NumberFormat('en-US',
    {
        style,
        currency,
        notation: 'compact',
        currencyDisplay: 'narrowSymbol'
    })

export const trimAmountZeros = (amount: string): string => amount?.replace(/(?:\.0*|(\.\d+?)0+)(?=\.|$)/g, '$1')
